<template>
	<div class="app">
		<div class="big-head">
			<div class='big-head-box' >
				<img src="@/assets/logo.png" class="big-head-box1-img" />
			</div>
			<div class='big-head-box' @mouseenter="gopage(0)">{{langflg?'首页':'HOME'}}</div>
			<div class='big-head-box' @mouseenter="gopage(1)">{{langflg?'集团介绍':'GROUP INTRODUCTION'}}</div>
			<div class='big-head-box' @mouseenter="gopage(2)">{{langflg?'全球服务':'GLOBAL'}}</div>
			<div class='big-head-box' @mouseenter="gopage(3)">{{langflg?'公司优势':'ADVANTAGES'}}</div>
			<div class='big-head-box' @mouseenter="gopage(4)">{{langflg?'服务能力':'CASES'}}</div>
			<div class='big-head-box' @mouseenter="gopage(5)">{{langflg?'解决方案':'SOLUTION'}}</div>
			<div class='big-head-box' @mouseenter="gopage(6)">{{langflg?'联系我们':'CONTACT US'}}</div>
			<div class='big-head-box' style="width: 70px ;flex-grow: 0;flex-shrink: 0;">
				<img src="@/assets/switch.png" class="big-head-box2-img" @click="changelang" />
			</div>
		</div>
		<div class="big-centent" @mousewheel="mousewheelnow">
			<el-carousel direction="vertical" :autoplay="false" ref="pageswitch" height="100vh" trigger="click" :loop='false'>
				<el-carousel-item >
					<img src='@/assets/beijing.png' class="big-centent-beijing"></img>
					<div class="big-centent-banxin0">
						<div class="big-centent-1-left">
							<div class="big-centent-1-left-1">
								<img src="@/assets/leftyuan.png" alt="" />
								{{langflg?'蚂蚁链控股集团':'Ant Group'}}
							</div>
							<div class="big-centent-1-left-2" >
								{{langflg?'技术领先、质量至上、用芯智造':'Leading technology, quality first, and Smart Manufacturing with Core'}}
							</div>
							<div class="big-centent-1-left-3" >
								<!-- {{langflg?'第三方服务平台':' third-party service platform'}} -->
							</div>
							<img src="@/assets/anniu.png" alt=""  @click="nextpage()" v-if="langflg" style="cursor: pointer;" />
							<img src='@/assets/chakangengduo.png' alt=""  @click="nextpage()" v-if="!langflg" style="cursor: pointer;" />
						</div>
						<!-- <img class="big-centent-1-right" src="@/assets/firstimg.png" alt=""/> -->
					</div>
				</el-carousel-item>
				<el-carousel-item >
					<div class="big-centent-white">
						<div class="big-centent-banxin">
							<div class="big-centent-2-1" v-if="langflg">
								集团介绍/----
							</div>
							<div class="big-centent-2-1" v-if="!langflg" style="margin-top: 100px;left: -80px;">
								GROUP INTRODUCTION/----
							</div>
							<div class="big-centent-2-2">
								<div>{{langflg?'中国香港':'Hong Kong, China'}}</div>
								<div>{{langflg?'蚂蚁链控股集团':'Ant Group'}}</div>
							</div>
							<div class="big-centent-2-3">
								<div >
									香港蚂蚁控股集团(简称:蚂蚁控股)是一家集投资、区块链技术、人工智能大数据、云计算、区块链金融、外汇行生品交易、营销、传媒、服务器贸易、产业供应链等为一体，形成以金融助力科技为主的多元化产业投资控股公司。<br>
									Hong Kong Ant Holdings Group (referred to as Ant Holdings) is a diversified industrial investment holding company that integrates investment, blockchain technology, artificial intelligence big data, cloud computing, blockchain finance, foreign exchange banking and product trading, marketing, media, server trade, industrial supply chain, etc., forming a focus on financial support technology.
								</div>
								
								<div>
									<img src="@/assets/page2img.png" alt="" v-if="langflg" />
									<img src="@/assets/pc-1.png" alt="" v-if="!langflg" />
								</div>
							</div>
							
						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item >
					<div class="big-centent-black">
						<div class="big-centent-banxin">
							<div class="big-centent-2-1 big-centent-3-1">
								{{langflg?'全球服务':'GLOBAL'}}/----
							</div>
							<div class="big-centent-2-2 big-centent-3-2">
								<div>{{langflg?'全球服务':'GLOBAL'}}</div>
							</div>
							<div class="big-centent-3-3">
								<div v-if="langflg">
									<img src="@/assets/ditu.png" alt="" />
									<img src="@/assets/ditu.png" alt="" class="img2"/>
								</div>
								<div v-if="!langflg">
									<img src="@/assets/ditu3.png" alt="" />
									<img src="@/assets/ditu3.png" alt="" class="img2"/>
								</div>
							</div>
						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item >
					<div class="big-centent-white">
						<div class="big-centent-banxin1">
							<div class="big-centent-2-1" v-if="langflg" style="margin-left: 0px;margin-top: 70px;color: #fff;z-index: 999;">
								公司优势/----
							</div>
							<div class="big-centent-2-1"  v-if="!langflg" style="margin-left: 0px;margin-top: 70px;color: #fff;z-index: 999;">
								Advantages/----
							</div>
							<div class="big-centent-2-2"  v-if="langflg" style="color: #fff;" >
								<div>公司优势</div>
							</div>
							<div class="big-centent-2-2"  v-if="!langflg" style="color: #fff;">
								<div>Advantages</div>
							</div>
							<div class="big-img-4">
								<div style="width: 100%;height: 100%;position: relative;">
									<img src="@/assets/xxxx2.png" alt="" style="width: 100%;height: 100%;object-fit: cover;"  v-if="langflg" />
									<img src="@/assets/pc-2.png" alt=""  style="width: 100%;height: 100%;object-fit: cover;"   v-if="!langflg" />
								</div>
								
							</div>
						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item >
					<div class="big-centent-black">
						<div class="big-centent-banxin">
							<div class="big-centent-2-1" style="color:#fff" v-if='langflg' >
								服务能力/----
							</div>
							<div class="big-centent-2-1" style="color:#fff;margin-top: 10px;" v-if='!langflg' >
								Serviceability/----
							</div>
							<div class="big-centent-2-2" style="color:#fff" v-if='langflg' >
								<div>服务能力</div>
							</div>
							<div class="big-centent-2-2" style="color:#fff" v-if='!langflg' >
								<div>Serviceability</div>
							</div>
							<div class="big-centent-3-3" style="min-width: 800px;">
								<div >
									<div class="big-centent-5-boxparent">
										<div v-for="i in 36" :key="i" class="big-centent-5-box">
											<img :src='"@/assets/zanzhu/z ("+i+").png"' alt="" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item >
					<div class="big-centent-white">
						<div class="big-centent-banxin">
							<div class="big-centent-2-1" v-if="langflg">
								解决方案/----
							</div>
							<div class="big-centent-2-1" v-if="!langflg" style="margin-left: 0;margin-top:30px;">
								Solution/----
							</div>
							<div class="big-centent-2-2" v-if="langflg">
								<div>超算&隐私计算技术服务</div>
								<div>服务器定制</div>
							</div>
							<div class="big-centent-2-2" v-if="!langflg">
								<div style="font-size: 30px;">Supercomputing&Privacy Computing Technology Services</div>
								<div>Server customization</div>
							</div>
							<div style="width: 100%;height: calc(100% - 60px);padding-top: 250px;box-sizing: border-box;">
								<div style="width: 100%;height: 100%;text-align: center;box-sizing: border-box;padding: 0 150px;">

									<img src="@/assets/jiejue.png" alt="" style="width: 100%;height: 100%;object-fit: contain;" v-if="langflg" />
									<img src="@/assets/pc-3.png" alt="" style="width: 100%;height: 100%;object-fit: contain;" v-if="!langflg" />
								</div>
								
							</div>
						</div>
					</div>
				</el-carousel-item>
				<el-carousel-item >
					<div class="big-centent-black">
						<div class="big-centent-banxin">
							<div class="big-centent-2-1" style="color:#fff" v-if="langflg">
								联系我们/----
							</div>
							<div class="big-centent-2-1" style="color:#fff"  v-if="!langflg">
								Contact Us/----
							</div>
							<div class="big-centent-2-2" style="color:#fff"  v-if="langflg">
								<div>联系我们</div>
							</div>
							<div class="big-centent-2-2" style="color:#fff"  v-if="!langflg">
								<div>Contact Us</div>
							</div>
							<div class="big-centent-3-3" style="min-width: 800px;">
								<div >
									<div class="big-centent-7">
										<div class="big-centent-7-1">
											<div class="big-centent-7-1-1">
												<div class="big-centent-7-1-1-1"><el-input v-model="mes.name" placeholder="Enter Your Name" ></el-input></div>
												<div class="big-centent-7-1-1-1"><el-input v-model="mes.email" placeholder="Enter Your E-mail"></el-input></div>
												<div class="big-centent-7-1-1-1"><el-input v-model="mes.message" placeholder="Type Message Here" type="textarea" :rows="10"></el-input></div>
												<div class="small-8-2" @click="sendmsg">SEND MESSAGE</div>
											</div>
											
										</div>
										<div class="big-centent-7-1">
											<div class="big-centent-7-1-2">
												<div>
													
												</div>
												<div>
													
												</div>
												<div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-carousel-item>
				
			</el-carousel>
			
		</div>
	</div>
</template>

<script>
import axios from "axios";

export default {
	data() {
		return{
			mes:{
				name:'',
				email:'',
				message:''
			},
			pageflag:true,
			langflg:true
		}
	},
	methods:{
		changelang(){
			this.langflg=!this.langflg
		},
		gopage(num){
			this.$refs.pageswitch.setActiveItem(num)
		},
		mousewheelnow(e){
			console.log( e.wheelDelta);
			if(this.pageflag){
				this.pageflag=false
				if( e.wheelDelta<0){
					this.$refs.pageswitch.next()
				}else{
					this.$refs.pageswitch.prev()
				}
				setTimeout(()=>{
					this.pageflag=true
				},300)
			}
			
		},
		nextpage(){
			this.$refs.pageswitch.next()
		},
		sendmsg(){
			if(this.mes.email==''||this.mes.message==''||this.mes.name==''){
				this.$message({
				  message: '请填写完整信息',
				  type: 'warning'
				});
			}
			axios({
				method: "post",
				url: "/xx",
				params:{ 
					...this.mes
				}
			}).then(x=>{
				if(x.data=='发送成功'){
					this.$message({
					  message: '发送成功',
					  type: 'success'
					});
				}else{
					this.$message({
					  message: '发送失败',
					  type: 'warning'
					});
				}
			})
		}
	}
}
</script>

<style scoped>
body{
	margin: 0 !important;
	padding: 0 !important;
	position: relative;
}
.app{
	position: fixed;
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
}
.big-head{
	width: 100%;
	height: 56px;
	background-color: rgb(11, 33, 56);
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;
	display: flex;
}
.big-head-box{
	flex-wrap: nowrap;
	flex-grow: 1;
	flex-shrink: 1;
	text-align: center;
	
	font-size: 16px;
	color: #fff;
	line-height: 56px;
	user-select: none;
}
.big-head-box:nth-child(1){
	flex-grow: 1.5;
}
.big-head-box:last-child{
	flex-grow: 2;
}
.big-head-box:not(.big-head-box:nth-child(1),.big-head-box:last-child):hover{
	background-color: rgb(21, 65, 109);
	
}


.big-head-box1-img{
	height: calc(100% - 20px);
	margin-top: 10px;
	position: relative;
}
.big-head-box1-text{
	position: relative;
	height: 56px;
	line-height: 56px;
	font-size: 24px;
	display: inline-block;
	margin-left: 12px;
}
.big-head-box2-img{
	width: 24px;
	height: 24px;
	position: relative;
	top: 4px;
}

.big-centent{
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	padding-top: 56px;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
}
.big-centent-banxin0{
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 2;
}
.big-centent-beijing{
	width: 100%;
	height: 100%;
	object-fit: cover;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1;
}
.el-carousel__item{
	
	
	background-color: #fff;
}

.el-carousel{
	
	background-color: #fff;
	margin-top: -2px;
}

/* .big-centent-6-1{
	width: 100%;
	height: 100% !important;
	position: relative !important;
	background-color: #fff;
	box-sizing: border-box;
	padding-top: 56px;
} */
.big-centent-white{
	width: 100%;
	height: 100%;
	position: fixed;
	background-color: #fff;
	box-sizing: border-box;
}
.big-centent-black{
	width: 100%;
	height: 100%;
	position: fixed;
	background-color: #001C1C;
	box-sizing: border-box;
}
.big-centent-banxin{
	width: 100%;
	max-width: 1500px;
	height: 100%;
	position: relative;
	margin-left: auto;
	margin-right: auto;
	left: 0;
	right: 0;
}
.big-centent-banxin1{
	width: 100%;
	height: 100%;
	position: relative;
	margin-left: auto;
	margin-right: auto;
	left: 0;
	right: 0;
}


.big-centent-1-left{
	position: absolute;
	height: 230px;
	margin-top: auto;
	margin-bottom: auto;
	top: 0;
	bottom: 0;
	left: 150px;
}
.big-centent-1-left>img:nth-child(4){
	width: 145px;
	height: 45px;
	position: relative;
	
	margin-top: 43px;
}
.big-centent-1-left-1{
	font-size: 24px;
	color: #fff;
}
.big-centent-1-left-1>img{
	width: 24px;
	height: 24px;
}
.big-centent-1-left-2{
	font-size: 59px;
	color: #fff;
	margin-top: 18px;
	margin-left: 15px;
}
.big-centent-1-left-3{
	font-size: 40px;
	color: #fff;
	margin-top: 18px;
	margin-left: 15px;
}
.big-centent-1-right{
	width: 562px;
	height: 562px;
	position: absolute;
	right: 150px;
	top: 56px;
	bottom: 0;
	margin-top: auto;
	margin-bottom: auto;
}



.big-centent-2-1{
	position: absolute;
	font-size: 24px;
	color: #303330;
	transform: rotate(90deg);
	top: 80px;
	
}
.big-centent-2-2{
	font-size: 54px;
	color: #303330;
	top: 100px;
	position: absolute;
	left: 150px;
	z-index: 12;
}
.big-centent-2-2>div:nth-child(1){
	line-height: 24px;
	border-bottom: 30px solid #783CEC;
	display: inline-block;
	z-index: 12;
}
.big-centent-2-3{
	font-size: 14px;
	position: absolute;
	box-sizing: border-box;
	padding: 300px 150px 0;
	height: calc(100% - 55px);
	top: 0;
	line-height: 24px;
	z-index: 5;
	display: flex;
	flex-direction: column;
}
.big-centent-2-3>div:nth-child(1){
	width: 100%;
	flex-grow: 0;
	flex-shrink: 0;
	
}
.big-centent-2-3>div:nth-child(2){
	width: 100%;
	flex-grow: 1;
	flex-shrink: 1;
	height: 0;
	box-sizing: border-box;
	padding-top: 15px;
}
.big-centent-2-3>div:nth-child(2)>img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.big-centent-3-1{
	color: #fff;
}
.big-centent-3-2{
	color: #fff;
}
.big-centent-3-3{
	
	position: absolute;
	box-sizing: border-box;
	max-width: 1500px;
	width: 100%;
	height: 100%;
	padding: 200px 150px 70px;
}
.big-centent-3-3>div:nth-child(1){
	width: 100%;
	height: 100%;
	position: relative;
	overflow: hidden;
}
.big-centent-3-3>div>img{
	width: 100%;
	position: absolute;
	animation: 30s linear rightMove infinite;
	float: left;
	top: 0;
	bottom: 0;
	margin-top: auto;
	margin-bottom: auto;
}
.img2{
	margin-left: 100%;
}
.big-centent-3-3-box{
	width: 100%;
	height: 270px;
	position: absolute;
	position: absolute;
	top: 0;
	bottom: 0;
	margin: auto 0;
	display: flex;
	flex-wrap: wrap;
}
.big-centent-3-3-item{
	width: 45%;
	height: 120px;
	background-color: rgba(0, 28, 28, 0.03);
	flex-grow: 1;
	flex-shrink: 0;
	border-radius: 12px;
	position: relative;
	display: flex;
}
.big-centent-3-3-item:nth-child(2n-1){
	margin-right: 15px;
}
.big-centent-3-3-item>img{
	width: 100px;
	height: 100px;
	margin-top: 10px;
	margin-left: 10px;
	border-radius: 6px;
	position: relative;
	flex-grow: 0;
	flex-shrink: 0;
}

.big-centent-3-3-text2>div:nth-child(1){
	width: 10px;
	height: 10px;
	background-color: #02A930;
	border-radius: 50%;
	display: inline-block;
	margin-right: 5px;
}
.big-centent-3-3-text2>div:nth-child(2){
	display: inline-block;
	color: #303330;
}



.big-centent-3-3-item-box{
	width: 100%;
	height: 100%;
	
	flex-grow: 1;
	flex-shrink: 1;
	position: relative;
	display: flex;
	flex-direction: column;
}
.big-centent-3-3-item-box>div{
	width: 100%;
	flex-grow: 1;
	flex-shrink: 1;
}
.big-centent-3-3-item-box>div:nth-child(1){
	height: 100px;
}
.big-centent-3-3-item-box>div:nth-child(3){
	height: 100px;
}
.big-centent-3-3-item-box-1{
	position: relative;
	color: #616361;
	font-size: 15px;
	flex-grow: 0;
	flex-shrink: 0;
	box-sizing: border-box;
	padding: 0 15px;
	line-height: 1.5;
}
.big-centent-3-3-item-box-2{
	text-align: center;
	position: absolute;
	font-size: 18px;
	width: 100%;
	background-color: rgb(247, 247, 247);
	border-radius: 12px;
	z-index: 10;
	height: 100%;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	opacity:1;
	color: #616361;
	
}
.big-centent-3-3-item-box-2:hover{
	opacity: 0;
	transition:opacity 0.1s linear;
}

.big-centent-3-3-item-box-2>div:nth-child(1){
	height: 100%;
	flex-grow: 1;
	flex-shrink: 1;
}
.big-centent-3-3-item-box-2>div:nth-child(3){
	height: 100%;
	flex-grow: 1;
	flex-shrink: 1;
}
.big-centent-3-3-item-box-2>div:nth-child(2){
	width: 100%;
	flex-grow: 0;
	flex-shrink: 0;
}

.big-centent-3-3-item-box-2>div:nth-child(2)>div{
	word-break: break-all;
	display: inline-block;
	
}
.big-centent-3-3-item-box-2>div:nth-child(2)>div>div:nth-child(1){
	width: 14px;
	height: 14px;
	background-color: #02A930;
	border-radius: 50%;
	display: inline-block;
	margin-right: 3px;
}


.big-centent-4-box{
	width: 750px;
	height: 520px;
	position: absolute;
	margin: auto;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
}


.big-centent-5-boxparent{
	width: 100%;
	position: absolute;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	
	margin-top: auto;
	margin-bottom: auto;
	top: 100px;
	bottom: 100px;
	box-sizing: border-box;
	padding: 0 0 200px 0;
}
.big-centent-5-box{
	position: relative;
	width: 11.1%;
	margin-top: 20px;
}
.big-centent-5-box>img{
	width: 90%;
	margin-left: 5%;
}
@keyframes rightMove {
	from {
		left: 0;
	}
	to {
		left: -100%;
	}
}
.big-centent-6-1-1{
	width: 49%;
	position: absolute;
	background-color: #ffffff;
	box-sizing: border-box;
	padding: 15px;
	border-radius: 10px;
	border: 1px solid #00000010;
	top: 0;
	bottom: 0;
	margin-top: auto;
	margin-bottom: auto;
	height: 520px;
	overflow: auto;
}
.big-centent-6-1-1:nth-child(1){
	left: 0;
}
.big-centent-6-1-1:nth-child(2){
	right: 0;
}
.big-centent-6-1-1>div:nth-child(1){
	font-size: 18px;
	line-height: 3;
}
.big-centent-6-1-1>div:nth-child(2){
	font-size: 16px;
	line-height: 2;
}
.big-centent-7{
	width: 100%;
	height: 100%;
	position: absolute;
	display: flex;
	flex-wrap: nowrap;
}
.big-centent-7-1:nth-child(1){
	width: 49%;
	height: 100%;
	flex-grow: 1;
	flex-shrink: 0;
	position: relative;
	
}
.big-centent-7-1-1{
	width: 100%;
	height: 350px;
	position: absolute;
	top: 0;
	bottom: 0;
	margin-top: auto;
	margin-bottom: auto;
}






.big-centent-7-1:nth-child(2){
	width: 300px;
	height: 100%;
	flex-grow: 1;
	flex-shrink: 0;
	
	position: relative;
}
.big-centent-7-1-2{
	position: absolute;
	color: #fff;
	width: 100%;
	top: 0;
	bottom: 0;
	margin-top: auto;
	margin-bottom: auto;
	height: 350px;
	box-sizing: border-box;
	padding-left: 20px;
}

.big-centent-7-1-2>div:nth-child(1){
	font-size: 18px;
	color: #fff;
	line-height: 60px;
}
.big-centent-7-1-2>div:nth-child(2){
	font-size: 12px;
	color: #fff;
	
}
.big-centent-7-1-2>div:nth-child(3){
	font-size: 18px;
	color: #02A930;
	margin-top: 59px;
	line-height: 50px;
}
.big-centent-7-1-1-1{
	width: 100%;
	margin-top: 15px;
}
 /deep/.el-input__inner {
  background-color: rgba(255, 255, 255, 0.2) !important;
  color: #fff;
  border: 1px  rgba(255, 255, 255, 0.2);
}
 /deep/ .el-textarea__inner{
	 background-color: rgba(255, 255, 255, 0.2) !important;
	 color: #fff;
	 border: 1px  rgba(255, 255, 255, 0.2);
 }
.small-8-2{
	padding: 10px 20px;
	background-color: #783CEC;
	font-size: 17px;
	color: #fff;
	font-weight: 100;
	margin-top: 20px;
	display: inline-block;
	user-select: none;
	position: relative;
}
.big-img-4{
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	position: absolute;
}
</style>
